export const suggestionButtonDataSet = { cy: 'suggestion-button' };
